import { Stack } from "@mui/material";
import CustomTabs from "components/Organisms/tabs/customTabs";
import CustomerDetailsHeader from "components/Organisms/users/customers/customerDetailsHeader";
import DriverEmoloyeeDetailsHeader from "components/Organisms/users/drivers/employee/driverDetailsHeader";

export default function EmployeeDetailsTemplate({
  details,
  tabs,
  selectedTab,
  handleTabChange,
  actionsList,
}) {
  return (
    <Stack>
      <DriverEmoloyeeDetailsHeader
        data={details}
        actionsList={actionsList}
      />
      <CustomTabs
        tabs={tabs}
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
      />
    </Stack>
  );
}
